import CityPageTemplate from "../city-template/CityPageTemplate";
import { charlotteConfig } from "./data";

export default function CharlottePage() {
  return <CityPageTemplate config={charlotteConfig} />;
}